/* wakumo custom JS */
/* カラースウォッチ: 「カラー:」行に自前のカラー名表示を追加（Kallesの表示要素に依存しない） */
(function(){
  function badge(item){
    var opt = item.closest('[data-swatch-option]');
    if(!opt) return null;
    /* ドロップダウン方式のオプション（サイズ等）はボタン内に選択値が出るため対象外 */
    if(opt.querySelector('[data-dropdown-open]')) return null;
    var h4 = opt.querySelector('.t4s-swatch__title');
    if(!h4) return null;
    var b = h4.querySelector('.wakumo-cur-value');
    if(!b){
      b = document.createElement('span');
      b.className = 'wakumo-cur-value';
      h4.appendChild(b);
    }
    return b;
  }
  function valueOf(item){
    return item.dataset.value || item.textContent.trim();
  }
  document.addEventListener('mouseover', function(e){
    if(!e.target || !e.target.closest) return;
    var item = e.target.closest('[data-swatch-item]');
    if(!item) return;
    var b = badge(item);
    if(b) b.textContent = valueOf(item);
  }, true);
  document.addEventListener('mouseout', function(e){
    if(!e.target || !e.target.closest) return;
    var item = e.target.closest('[data-swatch-item]');
    if(!item) return;
    var b = badge(item);
    if(!b) return;
    var opt = item.closest('[data-swatch-option]');
    b.textContent = (opt && opt.dataset.wakumoSelected) || '';
  }, true);
  /* スウォッチのカラーに対応するギャラリースライドへ移動 */
  function gotoColorSlide(colorName){
    try{
      var gallery = document.querySelector('[data-main-media]');
      if(!gallery || !window.Flickityt4s) return;
      var carouselEl = gallery.hasAttribute('data-flickityt4s-js') ? gallery : gallery.querySelector('[data-flickityt4s-js]');
      if(!carouselEl) return;
      var inst = Flickityt4s.data(carouselEl);
      if(!inst) return;
      var slides = carouselEl.querySelectorAll('[data-main-slide]');
      var target = 'swatch:' + colorName;
      for(var i=0;i<slides.length;i++){
        var img = slides[i].querySelector('img');
        var alt = img ? (img.getAttribute('alt') || '') : '';
        if(alt === target){
          inst.select(i);
          return;
        }
      }
    }catch(err){ /* 取得できない構成では何もしない */ }
  }

  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    var item = e.target.closest('[data-swatch-item]');
    if(!item) return;
    var opt = item.closest('[data-swatch-option]');
    var b = badge(item);
    if(opt) opt.dataset.wakumoSelected = valueOf(item);
    if(b) b.textContent = valueOf(item);
    if(b && item.style.backgroundImage){ gotoColorSlide(valueOf(item)); }
  }, true);
  /* 初期表示: 選択済みスウォッチがあれば反映（?variant=付き流入対応） */
  document.addEventListener('DOMContentLoaded', function(){
    var sels = document.querySelectorAll('[data-swatch-option] [data-swatch-item].is--selected');
    for(var i=0;i<sels.length;i++){
      var item = sels[i];
      var opt = item.closest('[data-swatch-option]');
      var b = badge(item);
      if(opt) opt.dataset.wakumoSelected = valueOf(item);
      if(b) b.textContent = valueOf(item);
    }
  });
})();

/* ============================================
   インラインバリデーション
   - バリアント未選択: 該当の選択肢を赤くハイライトして誘導
   - 同意チェック未了: チェックボックスを赤枠で強調
   （従来の画面下トースト通知は出さない）
   ============================================ */
(function(){
  function clearError(el){ if(el) el.classList.remove('wakumo-error'); }

  /* --- バリアント未選択 --- */
  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-atc-form]');
    if(!btn) return;
    if(btn.getAttribute('aria-disabled') !== 'true' && !btn.hasAttribute('disabled')) return;
    /* 未選択のオプションを特定してマーク */
    var form = btn.closest('.t4s-product-form__variants') || btn.closest('form') || document;
    var opts = form.querySelectorAll('[data-swatch-option]');
    var first = null;
    for(var i=0;i<opts.length;i++){
      if(!opts[i].querySelector('[data-swatch-item].is--selected')){
        opts[i].classList.add('wakumo-error');
        if(!first) first = opts[i];
      }
    }
    if(first){
      e.preventDefault();
      e.stopPropagation();  /* Kallesのトースト通知を抑止 */
      first.scrollIntoView({behavior:'smooth', block:'center'});
    }
  }, true);

  /* 選択したらそのオプションのエラーを解除 */
  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    var item = e.target.closest('[data-swatch-item]');
    if(!item) return;
    clearError(item.closest('[data-swatch-option]'));
  }, true);

  /* --- 同意チェック未了 --- */
  document.addEventListener('click', function(e){
    if(!e.target || !e.target.closest) return;
    var btn = e.target.closest('button[name="checkout"], .t4s-btn__checkout');
    if(!btn) return;
    var boxes = document.querySelectorAll('[data-agree-checkbox]');
    var bad = null;
    for(var i=0;i<boxes.length;i++){
      if(!boxes[i].checked){ bad = boxes[i]; break; }
    }
    if(bad){
      e.preventDefault();
      e.stopPropagation();  /* Kallesのトースト通知を抑止 */
      var wrap = bad.closest('.t4s-cart__agree') || bad.parentElement;
      wrap.classList.add('wakumo-error');
      wrap.scrollIntoView({behavior:'smooth', block:'center'});
    }
  }, true);

  document.addEventListener('change', function(e){
    if(!e.target || !e.target.closest) return;
    if(e.target.hasAttribute && e.target.hasAttribute('data-agree-checkbox') && e.target.checked){
      clearError(e.target.closest('.t4s-cart__agree') || e.target.parentElement);
    }
  }, true);
})();
